import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-slider',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent {
  @Input() value: number = 0;
  @Input() min: number = 0;
  @Input() max: number = 100;
  @Input() step: number = 1;
  @Input() label: string = '';
  @Input() unit: string = '';
  @Input() showTicks: boolean = false;
  @Input() showButtons: boolean = true;
  @Output() valueChange = new EventEmitter<number>();

  get displayValue(): string {
    return `${Math.round(this.value)}${this.unit}`;
  }

  get ticks(): number[] {
    const tickCount = 5;
    const range = this.max - this.min;
    const tickStep = range / (tickCount - 1);
    return Array.from({ length: tickCount }, (_, i) => this.min + (i * tickStep));
  }

  onValueChange(value: number): void {
    this.value = value;
    this.valueChange.emit(value);
  }

  handleInputChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.onValueChange(+target.value);
  }

  increment(): void {
    const newValue = Math.min(this.max, this.value + this.step);
    this.onValueChange(newValue);
  }

  decrement(): void {
    const newValue = Math.max(this.min, this.value - this.step);
    this.onValueChange(newValue);
  }
}